import get from 'lodash/get'

export const getError = (error: any) => {
  const errorMessage =
    get(error, 'response.data.error.message') || get(error, 'response.data.message') || error.message
  return errorMessage
}